/* eslint-disable */
// @ts-nocheck
import {
  BACKEND_API_BASE_URL,
  DATALAYER_EVENTS,
  DISCORD_BOTS,
  SCREENS_EXCLUDED_FOR_CLAIM_PAYLOAD,
  SUB2_EVENTS,
  TiktokPixel_EVENTS,
} from '@/services/constants';
import { loadFromStorage, saveToStorage } from '@/utils/client-storage/localStorage';
import { loadFromSessionStorage } from './client-storage/sessionStorage';
import { getJourneyVersion } from '@/routes/journey.routes';

let KountSessionIDFailSafe: any = null;
let fallBackOmniscore = null;
let fallBackSCOR = null;
let fallBackClaimNumber = null;
const MAX_RETRIES = 3; // Maximum number of retries
const RETRY_DELAY = 1000; // Delay between retries in milliseconds
const turnOffPixels = true;

export const getKountFailSafeValue = () => {
  return KountSessionIDFailSafe;
};

export const setKountFailSafeValue = (value = '') => {
  KountSessionIDFailSafe = value;
};

export const shouldIncludeScreenName = (screenName: string): boolean =>
  !SCREENS_EXCLUDED_FOR_CLAIM_PAYLOAD.some((screen) => screenName.includes(screen));

export const getAndStoreVersion = (): string => {
  try {
    const url = new URL(window.location.href);
    const version = url.searchParams.get('source');

    if (version) {
      saveToStorage('version', version);

      //   if (!skipDBSave) {
      //     handleClaimUpsert({ journey: version });
      //   }
      return version;
    } else {
      const host = window.location.href.toLowerCase();
      const hostMappings: Record<string, string> = {
        'mail.fair.inc': 'c',
        'www.fair.inc': 'c',
        'mailonline.fair.inc': 'c',
        'check.fair.inc': 'c',
        'digital.fair.inc': 'c',
      };
      const matchedKey = Object.keys(hostMappings).find((key) => host.includes(key));
      const defaultValue = matchedKey ? hostMappings[matchedKey] : 'c';

      saveToStorage('version', defaultValue);

      //   if (!skipDBSave) {
      //     handleClaimUpsert({ journey: defaultValue });
      //   }
      return defaultValue;
    }
  } catch (error) {
    console.error('Error parsing URL or accessing localStorage:', error);
    const host = window.location.href.toLowerCase();
    const hostMappings: Record<string, string> = {
      'mail.fair.inc': 'c',
      'www.fair.inc': 'c',
      'mailonline.fair.inc': 'c',
      'check.fair.inc': 'c',
      'digital.fair.inc': 'c',
    };
    const matchedKey = Object.keys(hostMappings).find((key) => host.includes(key));
    const defaultValue = matchedKey ? hostMappings[matchedKey] : 'c';

    saveToStorage('version', defaultValue);

    // if (!skipDBSave) {
    //   handleClaimUpsert({ journey: defaultValue });
    // }
    return defaultValue;
  }
};
let ssrCookies: Record<string, string> = {};

export const getCookie = (name: string): string => {
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
  for (const cookie of cookies) {
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
  return '';
};

export const setCookie = (name: string, value: string, days = 10): void => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
  ssrCookies = { ...ssrCookies, [name]: value };
};

export const getSessionIDorGenerateOne = async () => {
  const sessionID = crypto.randomUUID().replace(/-/g, '');
  setKountFailSafeValue(sessionID);
  setCookie('KountSessionID', sessionID);
  return sessionID;
};

export const getLatestKountSessionID = async () => {
  return getCookie('KountSessionID') || getKountFailSafeValue();
};

export const processKountRiskInquiry = async () => {
  const claimNumber =
    loadFromStorage('currentId') || loadFromSessionStorage('currentId') || getCookie('currentId');
  const kountSessionId = getCookie('KountSessionID') || getKountFailSafeValue();
  const userAnswers = loadFromStorage('userAnswers');
  const payload = {
    session_id: kountSessionId || getKountFailSafeValue() || crypto.randomUUID().replace(/-/g, ''),
    email: userAnswers?.basicInfo?.email,
    phone: userAnswers?.basicInfo?.phone,
    claim_number: claimNumber,
    name: `${userAnswers?.basicInfo?.givenName || ''} ${userAnswers?.basicInfo?.surname || ''}`,
    address: userAnswers?.basicInfo?.address?.address,
    city: userAnswers?.basicInfo?.postTown,
    postalCode: userAnswers?.basicInfo?.postcode,
    country: userAnswers?.basicInfo?.country,
  };

  const url = `${BACKEND_API_BASE_URL}/kount`;
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'include',
  })
    .then(async (response) => {
      if (!response.ok) throw new Error('Kount response error');
      const kountResponse = await response.json();
      const {
        IP_COUNTRY = 'UNKNOWN',
        OMNISCORE = 0,
        SCOR = 0,
        IP_IPAD = ``,
        FINGERPRINT = ``,
        COOKIES = ``,
        JAVASCRIPT = ``,
        SESS = ``,
        MODE = ``,
      } = kountResponse.data?.responseObject || {};
      saveToStorage('risk-assessment', kountResponse.data);
      saveToStorage('OMNISCORE', OMNISCORE);
      saveToStorage('SCOR', SCOR);

      fallBackOmniscore = OMNISCORE;
      fallBackSCOR = SCOR;
      /**
       * triggering after contact page. Pls trigger then and add persona,
       * omniscore, geo  and lead source (fb/tiktok/display/direct) to the BOTs
       *   */

      const info = userAnswers?.basicInfo;
      triggerDiscordMessage({
        content: `# Claim Number: **${claimNumber}**
        - Entry Point: **${window.location.href}**
        - Name: **${info?.givenName} ${info?.surname}**
        - DOB: **${info?.dob}**
        - Address: **${JSON.stringify(info?.address?.address)}**
        - Country(Kount): **${IP_COUNTRY}**
        - SessionID: **${kountSessionId}**
        - IP_IPAD: **${IP_IPAD}**
        - FINGERPRINT: **${FINGERPRINT}**
        - COOKIES: **${COOKIES}**
        - JAVASCRIPT: **${JAVASCRIPT}**
        - SESS: **${SESS}**
        - MODE: **${MODE}**`,
        bot: DISCORD_BOTS.KOUNT_COLLECTED,
      });
    })
    .catch((e) => {
      console.error('ERROR processing Kount', {
        e,
      });
    });
};

export const retrieveVersion = () => {
  const storedVersion = loadFromStorage('version') || 'c'; //'default';
  return storedVersion; // Return the stored version or null if not found
  // return 'c'; // Return the stored version or null if not found
};

export const getCurrentUTCDateTime = () => {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = (now.getUTCMonth() + 1).toString()?.padStart(2, '0'); // Month is 0-indexed
  const day = now.getUTCDate().toString()?.padStart(2, '0');
  const hours = now.getUTCHours().toString()?.padStart(2, '0');
  const minutes = now.getUTCMinutes().toString()?.padStart(2, '0');
  const seconds = now.getUTCSeconds().toString()?.padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

export const formatAgreementDate = (
  dateString: string // July 12, 2022
) => {
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  } catch (e) {
    return dateString;
  }
};

export const triggerDigiReachEvent = () => {
  const source = window.location.href;
  const transactionId = localStorage.getItem('transaction_id') || '';
  const isStageOrLocal =
    source?.startsWith('https://www.stage.fair.inc') || source?.startsWith('http://localhost');
  if (transactionId === '') {
    console.log('No transactionId found');
    return null;
  }
  if (isStageOrLocal) {
    console.log(`STAGE: Tried to trigger digi reach event: ${transactionId}`);
    return null;
  }
  const isNotDigiReach = !source?.startsWith('https://digital.fair.inc');
  if (isNotDigiReach) {
    console.log('Not a DigiReach page, not sending postback');
    return null;
  }
  fetch(`${BACKEND_API_BASE_URL}/digi-reach/postback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ transactionId: transactionId }),
  });
};

export const getLoanPercentage = (loan: any) => {
  //  (loan end date - start date) in months / no of periods loan %
  const startDate =
    loan.startDate ||
    (loan.caisAccStartDate
      ? `${loan.caisAccStartDate.ccyy}-${loan.caisAccStartDate.mm}-${loan.caisAccStartDate.dd}`
      : null);
  const endDate =
    loan.endDate ||
    (loan.settlementDate
      ? `${loan.settlementDate.ccyy}-${loan.settlementDate.mm}-${loan.settlementDate.dd}`
      : null);
  if (!endDate || !startDate) return 0;
  const { fixedPaymentTerms = {}, repaymentPeriod } = loan;
  const periods = repaymentPeriod ? Number(repaymentPeriod) : fixedPaymentTerms?.periods || 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  const monthsDifference =
    (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  if (monthsDifference <= 0 || periods <= 0) return 0; // Avoid division by zero
  const percentage = (monthsDifference / periods) * 100;
  const result = Math.round(percentage * 100) / 100; // Round to two decimal
  return result > 100 ? 100 : result; // Ensure it doesn't exceed 100%
};

export const getIP = (callback: any) => {
  fetch('https://api.ipify.org?format=json')
    .then((response) => response.json())
    .then((data) => callback(data.ip))
    .catch((error) => callback(null, error));
};

export const getIPAsync = async () => {
  const response = await fetch('https://api.ipify.org?format=json');
  const data = await response.json();
  return data.ip;
};

async function sendGTMServerEventWithRetries(
  claimNumber: string,
  accessToken: any,
  eventId: string,
  ip: string,
  hashedEmail: string,
  hashedPhone: string,
  fbc: string,
  fbp: string,
  event_key: string,
  fname: string,
  lname: string,
  ttclid: string,
  ttp: string,
  leadSource: string,
  leadPayload = {},
  db
) {
  const eventData = {
    event_name: eventId,
    event: eventId,
    event_id: event_key.replace(/[-_]/g, ''),
    event_time: Math.floor(Date.now() / 1000),
    host: leadSource,
    // event_source_url: `${window.location.hostname}${window.location?.pathname}`,
    // action_source: "website",
    user_data: {
      client_ip_address: `${ip}`,
      client_user_agent: navigator.userAgent,
      em: hashedEmail,
      ph: hashedPhone,
      fn: fname,
      ln: lname,
      fbc: fbc,
      fbp: fbp,
      ttclid,
      ttp,
      db,
    },
    context: {
      user: {
        ip: `${ip}`,
        user_agent: navigator.userAgent,
        email: hashedEmail,
        phone_number: hashedPhone,
        fbc: fbc,
        fbp: fbp,
        ttclid,
        ttp,
        external_id: event_key.replace(/[-_]/g, ''),
      },
      ad: {
        callback: ttclid,
      },
    },
    ...leadPayload,
  };

  const config = {
    // headers: {}
  };

  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    try {
      const response = await fetch(`${BACKEND_API_BASE_URL}/trigger-gtm-event`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: eventData }),
      });
      if (!response.ok) throw new Error('GTM event failed');
      return await response.json();
    } catch (error) {
      console.error(`Attempt ${attempt + 1} failed for event ${eventId}:`, error);

      // Send error message to Discord
      try {
        await triggerDiscordMessage({
          content: `Error in triggering sub2 event: ${eventId}\n
                  '''${JSON.stringify(error)?.substring?.(0, 2001)}'''`,
          bot: DISCORD_BOTS.TEST_BOT,
        });
      } catch (err) {
        console.error(
          'Failed to send error message to Discord during facebook pixel event sending:',
          err
        );
      }

      // If this was the last attempt, log the error and break the loop
      if (attempt === MAX_RETRIES - 1) {
        console.error(`All ${MAX_RETRIES} attempts failed for event: ${eventId}`);
        throw new Error(`All ${MAX_RETRIES} attempts failed for event: ${eventId}`); // Throw an error
      }

      // Wait before retrying
      console.log(`Waiting before next attempt to hit facebook pixel event: ${eventId}`);
      await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY));
    }
  }
}

export const getFallbackKountScore = (type = 'OMNISCORE') => {
  switch (type) {
    case 'OMNISCORE':
      return fallBackOmniscore || '0';
    case 'SCOR':
      return fallBackSCOR || '0';
    default:
      return fallBackOmniscore || '0';
  }
};

const OUTBRAIN_EVENTS = {
  [SUB2_EVENTS.lead_with_credit]: SUB2_EVENTS.lead_with_credit,
  [SUB2_EVENTS.Lead]: SUB2_EVENTS.Lead,
};

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const sendOutbrainPostback = (clickId: string, eventName: string) => {
  if (OUTBRAIN_EVENTS[eventName]) {
    const postbackUrl = `https://tr.outbrain.com/unifiedPixel?ob_click_id=${clickId}&name=${eventName}`;
    const sendPostback = async () => {
      try {
        const response = await fetch(postbackUrl, {
          method: 'GET',
        });

        if (!response.ok) {
          console.error('Postback request failed', response);
        }
      } catch (error) {
        console.error('Error sending postback:', error);
      }
    };

    sendPostback();
  }
};

const getBotKey = (bot: string) => {
  let tempKey = 'TEST_BOT';

  Object.keys(DISCORD_BOTS).forEach((botKey) => {
    if (DISCORD_BOTS[botKey as keyof typeof DISCORD_BOTS] === bot) {
      tempKey = botKey;
    }
  });

  return tempKey;
};

export const hashString = async (text: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  const hashHex = hashArray.map((b) => b.toString(16)?.padStart(2, '0')).join('');
  return hashHex;
};

export const triggerSub2DataLayer = (eventId: string, eventPayload = {}) => {
  if (!window.location.hostname.includes('social.fair.inc')) {
    return null;
  }
  // if ([SUB2_EVENTS.lead_with_credit, SUB2_EVENTS.LEAD_WITH_IDV].includes(eventId)) {
  //   try {
  //     localStorage.setItem(
  //       `lead_event_${eventId}`,
  //       `${parseInt(localStorage.getItem(`lead_event_${eventId}`) || '0') + 1}`
  //     );
  //   } catch (e) {}
  // }
  const source = window.location.href;
  const isStageOrLocal =
    source?.startsWith('https://www.stage.fair.inc') || source?.startsWith('http://localhost');
  if (isStageOrLocal) {
    return null;
  }

  let pixelId, accessToken, leadSource;
  if (source?.startsWith?.('https://reclaims.fair.inc')) {
    pixelId = '1163293635411298';
    accessToken =
      'EAAI9ZBIWYfpIBO3vSGJR2DH9hTS9IXZByqCtywuzxxZAwZAN3On7OSEMGe6Y4YraeBLaz4WGeKvbdZCGRGs36CsDIKVKKbQSTOEPB63a3KVERx66qAKsEa9j8gd6cdLwYZCEZAgntNBYXmnnjnFt2W5fUFZB3irDFOwjTClOAqR7x5pzdg26IuSJ1vhiKbV6xEDQDAZDZD';
    leadSource = 'https://reclaims.fair.inc';
    // pixelId = "1725241211571906";
    // accessToken = "EAAI9ZBIWYfpIBO3vSGJR2DH9hTS9IXZByqCtywuzxxZAwZAN3On7OSEMGe6Y4YraeBLaz4WGeKvbdZCGRGs36CsDIKVKKbQSTOEPB63a3KVERx66qAKsEa9j8gd6cdLwYZCEZAgntNBYXmnnjnFt2W5fUFZB3irDFOwjTClOAqR7x5pzdg26IuSJ1vhiKbV6xEDQDAZDZD";
  } else if (source?.startsWith?.('https://check.fair.inc')) {
    // pixelId = "1320204099178577";
    // // accessToken = "EAAI9ZBIWYfpIBO3vSGJR2DH9hTS9IXZByqCtywuzxxZAwZAN3On7OSEMGe6Y4YraeBLaz4WGeKvbdZCGRGs36CsDIKVKKbQSTOEPB63a3KVERx66qAKsEa9j8gd6cdLwYZCEZAgntNBYXmnnjnFt2W5fUFZB3irDFOwjTClOAqR7x5pzdg26IuSJ1vhiKbV6xEDQDAZDZD";
    // accessToken = "EAAI9ZBIWYfpIBO8x8SiT21W0d4U2ZAjO81M8OLR0DynMRCsNGwoZAqmzlLuZCHZCzJzbuiCdua7DPe6INTi20BMoGZCrHx9f1BkWYQhqwEjF6dxu1j7OeYxAI0FvlDF5dgSE6DNs0vOABIUbFieJgNoP4bOlkpD4zphSMmGZBQe1PZAu7KQ5egPMcNrPdIylag4ZCAgZDZD";
    leadSource = 'https://check.fair.inc';
    pixelId = '446869674890562';
    accessToken =
      'EAAM3QEHpOtsBOyOW0X0vOUg9N8ZASlB2uE5jtkJpCQjdnxZBlTikcaXkB8LMDJsFyH564XCkZCsLtNwz4UA94DE425ZCff7PbzYMlSllQtK0piFZBPtxUNlmsDBNP4wkTvfwiWunhf7rvZBiWjpWVEAnAvRUOOwy7o3kfMF20LDBw0Uw2kELweWtbd8XkS6UdznQZDZD';
  } else if (source?.startsWith?.('https://new.fair.inc')) {
    // pixelId = "1320204099178577";
    // // accessToken = "EAAI9ZBIWYfpIBO3vSGJR2DH9hTS9IXZByqCtywuzxxZAwZAN3On7OSEMGe6Y4YraeBLaz4WGeKvbdZCGRGs36CsDIKVKKbQSTOEPB63a3KVERx66qAKsEa9j8gd6cdLwYZCEZAgntNBYXmnnjnFt2W5fUFZB3irDFOwjTClOAqR7x5pzdg26IuSJ1vhiKbV6xEDQDAZDZD";
    // accessToken = "EAAI9ZBIWYfpIBO8x8SiT21W0d4U2ZAjO81M8OLR0DynMRCsNGwoZAqmzlLuZCHZCzJzbuiCdua7DPe6INTi20BMoGZCrHx9f1BkWYQhqwEjF6dxu1j7OeYxAI0FvlDF5dgSE6DNs0vOABIUbFieJgNoP4bOlkpD4zphSMmGZBQe1PZAu7KQ5egPMcNrPdIylag4ZCAgZDZD";
    leadSource = 'https://check.fair.inc';
    pixelId = '446869674890562';
    accessToken =
      'EAAM3QEHpOtsBOyOW0X0vOUg9N8ZASlB2uE5jtkJpCQjdnxZBlTikcaXkB8LMDJsFyH564XCkZCsLtNwz4UA94DE425ZCff7PbzYMlSllQtK0piFZBPtxUNlmsDBNP4wkTvfwiWunhf7rvZBiWjpWVEAnAvRUOOwy7o3kfMF20LDBw0Uw2kELweWtbd8XkS6UdznQZDZD';
  } else if (source?.startsWith?.('https://find.fair.inc')) {
    pixelId = '1306369483984425';
    accessToken =
      'EAAI9ZBIWYfpIBO3vSGJR2DH9hTS9IXZByqCtywuzxxZAwZAN3On7OSEMGe6Y4YraeBLaz4WGeKvbdZCGRGs36CsDIKVKKbQSTOEPB63a3KVERx66qAKsEa9j8gd6cdLwYZCEZAgntNBYXmnnjnFt2W5fUFZB3irDFOwjTClOAqR7x5pzdg26IuSJ1vhiKbV6xEDQDAZDZD';
    leadSource = 'https://find.fair.inc';
  } else if (source?.startsWith?.('https://mail.fair.inc')) {
    pixelId = '982782316511194';
    accessToken =
      'EAAI9ZBIWYfpIBO3vSGJR2DH9hTS9IXZByqCtywuzxxZAwZAN3On7OSEMGe6Y4YraeBLaz4WGeKvbdZCGRGs36CsDIKVKKbQSTOEPB63a3KVERx66qAKsEa9j8gd6cdLwYZCEZAgntNBYXmnnjnFt2W5fUFZB3irDFOwjTClOAqR7x5pzdg26IuSJ1vhiKbV6xEDQDAZDZD';
    leadSource = 'https://mail.fair.inc';
  } else if (source?.startsWith?.('https://connect.fair.inc')) {
    pixelId = '1635083703770345';
    accessToken =
      'EAAI9ZBIWYfpIBO3vSGJR2DH9hTS9IXZByqCtywuzxxZAwZAN3On7OSEMGe6Y4YraeBLaz4WGeKvbdZCGRGs36CsDIKVKKbQSTOEPB63a3KVERx66qAKsEa9j8gd6cdLwYZCEZAgntNBYXmnnjnFt2W5fUFZB3irDFOwjTClOAqR7x5pzdg26IuSJ1vhiKbV6xEDQDAZDZD';
    leadSource = 'https://connect.fair.inc';
  } else if (source?.startsWith?.('https://claim.fair.inc')) {
    // pixelId = "1789163888603129";
    pixelId = '1019267763731123';
    accessToken =
      'EAAI9ZBIWYfpIBO3vSGJR2DH9hTS9IXZByqCtywuzxxZAwZAN3On7OSEMGe6Y4YraeBLaz4WGeKvbdZCGRGs36CsDIKVKKbQSTOEPB63a3KVERx66qAKsEa9j8gd6cdLwYZCEZAgntNBYXmnnjnFt2W5fUFZB3irDFOwjTClOAqR7x5pzdg26IuSJ1vhiKbV6xEDQDAZDZD';
    leadSource = 'https://claim.fair.inc';
  } else if (source?.startsWith?.('https://submit.fair.inc')) {
    pixelId = '1019267763731123';
    accessToken =
      'EAAI9ZBIWYfpIBO3vSGJR2DH9hTS9IXZByqCtywuzxxZAwZAN3On7OSEMGe6Y4YraeBLaz4WGeKvbdZCGRGs36CsDIKVKKbQSTOEPB63a3KVERx66qAKsEa9j8gd6cdLwYZCEZAgntNBYXmnnjnFt2W5fUFZB3irDFOwjTClOAqR7x5pzdg26IuSJ1vhiKbV6xEDQDAZDZD';
    leadSource = 'https://submit.fair.inc';
  } else if (source?.startsWith?.('https://direct.fair.inc')) {
    pixelId = '1287845198939073';
    accessToken =
      'EAAI9ZBIWYfpIBOySW3RQNmkG962jCTjFkbU55mYQ9V880KiPWNCsXyVdUlkn4FEltEBsbEWz07IjOypFXifqmW70pN96mhJ52thKL6ZBMrKOmwaeZAdg1xIPRZA4TAkr2cjxGPp2F0y5FZA7dgZBPVpxWJgpVYRQyNCVGdXRJ9KGZBo3upeIMjXbz1WwUXs5YERZBQZDZD';
    leadSource = 'https://direct.fair.inc';
  } else if (source?.startsWith?.('https://social.fair.inc')) {
    pixelId = '619874984328933';
    accessToken =
      'EAAI9ZBIWYfpIBO9YmloT8ybKQPsBuOVsglsWB4MLNQQmFz36DSqJUZB6ILpH4aOvxfondkpJ5IPPa5NmKjkpHQ4wtP9ZBrKqt4eZAcouk04n4XioOJ95MaxcBTulNWNZAZAfZA0NMFtZAS0cSlVq7ZBZCp25adpwrUaIzsk3b2bOZCTI8HersIIccboHoD6K9Fw1RhtIAZDZD';
    leadSource = 'https://social.fair.inc';
  } else {
    // pixelId = "448467197650935"
    // accessToken = "EAANcNeEdddsBOzrF2zPWbeqnZBzIZBKQ6Qog1mZBNjjSoBfKrv2CawcokcpQXo1jKrpqwZBnDZA12QsKkotweXWnxYzvbEltR9xN81K89YkCj41otc8iD1ZCLvoh0XZA5NuvomsEZBlLtTIbxAliMpnH4o6FsZApnWBMXH06UK57fK6jE2U253ZAqG6eJeeCkRSidpZAwZDZD"

    pixelId = '619874984328933';
    accessToken =
      'EAAI9ZBIWYfpIBO9YmloT8ybKQPsBuOVsglsWB4MLNQQmFz36DSqJUZB6ILpH4aOvxfondkpJ5IPPa5NmKjkpHQ4wtP9ZBrKqt4eZAcouk04n4XioOJ95MaxcBTulNWNZAZAfZA0NMFtZAS0cSlVq7ZBZCp25adpwrUaIzsk3b2bOZCTI8HersIIccboHoD6K9Fw1RhtIAZDZD';
    leadSource = 'https://www.fair.inc';
  }

  const claimNumber = [SUB2_EVENTS.viewContent].includes(eventId)
    ? generateUUID()
    : loadFromStorage('currentId') || getCookie('currentId');
  const userAnswers = loadFromStorage('userAnswers');
  const fbp = getCookie('_fbp');
  const fbc = getCookie('_fbc');
  const ttp = getCookie('_ttp');
  const ttclid = getCookie('ttclid') || getCookie('_ttclid');
  const dicbo_id_encoded = getCookie('dicbo_id') || '{}';
  const dicbo_id_decoded = dicbo_id_encoded ? decodeURIComponent(dicbo_id_encoded) : '{}';
  const dicbo_id_json = dicbo_id_decoded ? JSON.parse(dicbo_id_decoded) : {};
  const dicbo_id = dicbo_id_json?.dicbo_fetch || '';

  // Generate event_key so that same can be used for data layer and CAPI deduplication
  // const event_key = `${claimNumber}_${DATALAYER_EVENTS[eventId] || eventId}`;
  // const event_key = `${claimNumber}_${TiktokPixel_EVENTS[eventId] || eventId}_${generateUUID()}`;
  // const event_key = `${claimNumber}_${TiktokPixel_EVENTS[eventId as keyof typeof TiktokPixel_EVENTS] || eventId}`;
  const event_key = `${claimNumber}_${eventId}`;

  let hashed_E = userAnswers?.basicInfo?.['email'] || '';
  let hashed_P = userAnswers?.basicInfo?.['phone'] || '';
  hashString(userAnswers?.basicInfo?.['email']).then((em) => {
    hashed_E = em;
  });
  hashString(userAnswers?.basicInfo?.['phone']).then((ph) => {
    hashed_P = ph;
  });
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  let leadPayload = {};

  switch (eventId) {
    case SUB2_EVENTS.lead_with_credit:
      leadPayload = {
        'tier_1/2': 'yes',
        pre_2021: 'yes',
        signup_status: 'yes',
        ...eventPayload,
      };
      break;
    case SUB2_EVENTS.credit_report:
      leadPayload = {
        'tier_1/2': 'no',
        pre_2021: 'yes',
        signup_status: 'no',
        ...eventPayload,
      };
      break;
    default:
      leadPayload = { ...eventPayload };
      break;
  }
  let hashedEmail = userAnswers?.basicInfo?.['yourEmail'] || '';
  let hashedPhone = userAnswers?.basicInfo?.['yourPhone'] || '';
  hashString(userAnswers?.basicInfo?.['yourEmail']).then((em) => {
    hashedEmail = em;
  });
  hashString(userAnswers?.basicInfo?.['yourPhone']).then((ph) => {
    hashedPhone = ph;
  });
  if (eventId.includes('CL_')) {
    setTimeout(() => {
      // @ts-ignore
      dataLayer.push({
        event: DATALAYER_EVENTS[eventId] || eventId,
        claim_id: `${event_key}`, // `${claimNumber}`,
        event_id: `${event_key}`, // `${claimNumber}`,
        email: hashedEmail,
        phone: hashedPhone,
        dob: userAnswers?.basicInfo?.['dateOfBirth'] || '',
        db: convertDateToYYYYMMDD(userAnswers?.basicInfo?.['dateOfBirth'] || ''),
        ...leadPayload,
      });
    }, 200);
  } else {
    // @ts-ignore
    dataLayer.push({
      event: DATALAYER_EVENTS[eventId] || eventId,
      claim_id: `${event_key}`, // `${claimNumber}`,
      event_id: `${event_key}`, // `${claimNumber}`,
      email: userAnswers?.basicInfo?.['yourEmail'] || '',
      phone: userAnswers?.basicInfo?.['yourPhone'] || '',
      dob: userAnswers?.basicInfo?.['dateOfBirth'] || '',
      db: convertDateToYYYYMMDD(userAnswers?.basicInfo?.['dateOfBirth'] || ''),
      ...leadPayload,
    });
  }
  getIP((ip: any, error: any) => {
    if (error) {
      console.error('Error getting IP address:', error);
    } else {
      let hashedEmail = userAnswers?.basicInfo?.['email'] || '';
      let hashedPhone = userAnswers?.basicInfo?.['phone'] || '';
      let fname = userAnswers?.basicInfo?.['givenName'] || '';
      let lname = userAnswers?.basicInfo?.['surname'] || '';
      hashString(userAnswers?.basicInfo?.['email']).then((em) => {
        hashedEmail = em;
      });
      hashString(userAnswers?.basicInfo?.['phone']).then((ph) => {
        hashedPhone = ph;
      });
      hashString(userAnswers?.basicInfo?.['givenName']).then((fn) => {
        fname = fn;
      });
      hashString(userAnswers?.basicInfo?.['surname']).then((ln) => {
        lname = ln;
      });

      setTimeout(() => {
        // ================== NEW CODE FOR FACEBOOK PIXEL EVENT FIRING END ==================

        // ================== NEW CODE FOR GTM SERVER EVENT FIRING START ==================
        // alert(leadSource);
        if (claimNumber && claimNumber !== '') {
          sendGTMServerEventWithRetries(
            claimNumber,
            accessToken,
            ttclid
              ? TiktokPixel_EVENTS[eventId as keyof typeof TiktokPixel_EVENTS] || eventId
              : eventId,
            ip,
            hashedEmail,
            hashedPhone,
            fbc,
            fbp,
            event_key,
            fname,
            lname,
            ttclid,
            ttp,
            leadSource,
            leadPayload,
            convertDateToYYYYMMDD(userAnswers?.basicInfo?.['dateOfBirth'] || '')
          )
            .then((data) => {
              console.log(`GTM server event sent successfully: ${eventId}`, data);
            })
            .catch((err) => {
              console.error('GTM server event failed:', err?.message);
            });
        }
        // ================== NEW CODE FOR GTM SERVER EVENT FIRING END ==================
        const tikTokPixelPayload = {
          event: TiktokPixel_EVENTS[eventId as keyof typeof TiktokPixel_EVENTS] || eventId,
          event_time: Math.floor(Date.now() / 1000),
          // "event_id": `${generateUUID()}`,
          // "event_id": `${claimNumber}_${TiktokPixel_EVENTS[eventId] || eventId}`,
          event_id: event_key, // `${claimNumber}`,
          user: {
            phone: hashedPhone,
            email: hashedEmail,
            ip: `${ip}`,
            user_agent: `${navigator.userAgent} || ''`,
            ttp,
            ttclid,
          },
          properties: {
            claim_id: `${event_key}`,
            lead_source: leadSource,
          },
        };
        !turnOffPixels &&
          console.log('TT Event :: ', {
            tikTokPixelPayload,
          });
        !turnOffPixels &&
          fetch(`${BACKEND_API_BASE_URL}/tiktok-event`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(tikTokPixelPayload),
          }).catch((err) => {
            console.error('ERROR while triggering server side event', err);
          });
        !turnOffPixels &&
          import('tiktok-pixel').then((module) => {
            const TiktokPixel = module.default;
            TiktokPixel.track(
              TiktokPixel_EVENTS[eventId as keyof typeof TiktokPixel_EVENTS] || eventId,
              {
                ...tikTokPixelPayload,
              }
            );
          });
      }, 500);
    }
  });
};

export const triggerDiscordMessage = ({
  content = '',
  bot,
  eventPayload = {},
  triggerSlack = true,
}: any) => {
  const userAnswers = loadFromStorage('userAnswers');
  const email = (userAnswers?.basicInfo?.email || '').toLowerCase();

  // Silence all notifications for test accounts
  if (email.includes('@fair.inc')) {
    return;
  }

  const referrer = loadFromStorage('referrer');
  const OMNISCORE = loadFromStorage('OMNISCORE') || '0';
  const SCOR = loadFromStorage('SCOR') || '0';
  const targetBotURL =
    window.location.href.includes('localhost') || window.location.href.includes('stage')
      ? DISCORD_BOTS.TEST_BOT
      : bot;
  const LogRocket = (window as any).LogRocket;
  fetch(targetBotURL, {
    body: JSON.stringify({
      content: `${
        LogRocket?.sessionURL
          ? `
        ${content}\n[Watch LogRocket Session Click Here](${LogRocket?.sessionURL})`
          : `${content}`
      }
        Source: \`${window.location.href}\`
        ${referrer ? `Referrer: \`${referrer}\`` : ''}
        Journey: **${retrieveVersion()}**
        Consolidated Rating: **${OMNISCORE}**
        Footprint Score: **${SCOR}**`,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });
  if (!triggerSlack) return;

  if (SUB2_EVENTS[bot as keyof typeof SUB2_EVENTS]) {
    triggerSub2DataLayer(SUB2_EVENTS[bot as keyof typeof SUB2_EVENTS], eventPayload);
  }

  // 🟢 Send to Slack via your backend

  const fullMessage = `${
    LogRocket?.sessionURL
      ? `${content}\n<${LogRocket.sessionURL}|Watch LogRocket Session Click Here>`
      : `${content}`
  }\n*Source:* \`${window.location.href}\`\n${
    referrer ? `*Referrer:* \`${referrer}\`` : ''
  }\n*Journey:* *${retrieveVersion()}*\n*Consolidated Rating:* *${OMNISCORE}*\n*Footprint Score:* *${SCOR}*`;
  const notificationsUrl = `${BACKEND_API_BASE_URL}/notifications`;
  fetch(notificationsUrl, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      channel: getBotKey(bot),
      text: fullMessage,
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      console.log('Notification sent:', res);
    })
    .catch((err) => {
      console.error('Error sending Notification:', err);
    });
};

export const handleZohoCreate = async (data) => {
  const source = window.location.href;
  const isStageOrLocal =
    source?.startsWith('https://www.stage.fair.inc') || source?.startsWith('http://localhost');
  if (isStageOrLocal) {
    return null;
  }
  const Email = data?.email || loadFromStorage('userAnswers')['basicInfo']['email'];
  const claimNumber = getClaimNumber() || data.Mongo_Client_Ref || '';
  if (claimNumber) {
    try {
      const response = await fetch(`${BACKEND_API_BASE_URL}/lead/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: [{ Email, ...data }] }),
      });
      if (response.status === 500 || response.status === 400) {
        await handleZohoUpsert(data);
      }
      triggerDiscordMessage({
        bot: DISCORD_BOTS.ZOHO_USER_CREATED,
        content: `New Lead Created in Zoho for Claim: ${claimNumber} and Email: ${Email || data?.email || loadFromStorage('userAnswers')['basicInfo']['email']}`,
      });
    } catch (e) {
      if (e.status === 500 || e.status === 400) {
        await handleZohoUpsert(data);
      } else {
        console.log('ERROR::lead creation', e);
      }
    }
  } else {
    triggerDiscordMessage({
      bot: DISCORD_BOTS.ZOHO_USER_CREATED,
      content: `Claimn Number or Email missing for Zoho Lead Creation. Claim: ${claimNumber} and Email: ${Email}`,
    });
  }
};

export const handleZohoUpsert_1 = async (data: any, type = 'lead', attempt = 0) => {
  if (attempt > 5) {
    return null;
  }
  const source = window.location.href;
  const isStageOrLocal =
    source?.startsWith('https://www.stage.fair.inc') || source?.startsWith('http://localhost');
  if (isStageOrLocal) {
    return null;
  }
  const Email = data?.email || loadFromStorage('userAnswers')?.basicInfo?.email || '';
  if (!Email.includes('test@fair.inc')) {
    try {
      let LEAD_UPSERT_API_PAYLOAD = {};
      Object.keys(data).forEach((key) => {
        if (key !== 'Base64_Signature') {
          LEAD_UPSERT_API_PAYLOAD = {
            ...LEAD_UPSERT_API_PAYLOAD,
            [key]: data[key],
          };
        }
      });
      const LEAD_API_URL = `${BACKEND_API_BASE_URL}/${type}`;
      const response = await fetch(LEAD_API_URL, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: [{ Email, ...LEAD_UPSERT_API_PAYLOAD }] }),
      });
      if (response.status === 500 || (response.status === 400 && type === 'lead')) {
        await handleZohoUpsert(data, 'contact', attempt + 1);
        return;
      }
      if (data.Base64_Signature) {
        const res = await updateClaim({
          ip_address: data?.Signature_IP_Address || '',
        }); // this will update the sign url if signature is present from backend
        const sign_url = res?.success ? res?.responseObject?.data?.signature_url : undefined;

        if (sign_url) {
          const curRes = await fetch(LEAD_API_URL, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              data: [
                {
                  Email,
                  Signature_URL: sign_url,
                  ...LEAD_UPSERT_API_PAYLOAD,
                },
              ],
            }),
          });
          console.log('ZOHO call completed:', curRes);
        } else {
          console.log('Skipping updateClaim as the URL is empty or invalid.');
        }
      }
    } catch (e) {
      console.log('ERROR::lead upsert', e);
      if (type === 'lead') {
        await handleZohoUpsert(data, 'contact', attempt + 1);
      }
    }
  }
};

export const handleZohoUpsert = async (data, type = 'lead', attempt = 0) => {
  if (attempt > 5) {
    return null;
  }
  const source = window.location.href;
  const isStageOrLocal =
    source?.startsWith('https://www.stage.fair.inc') || source?.startsWith('http://localhost');
  if (isStageOrLocal) {
    return null;
  }
  const Email = data?.email || loadFromStorage('userAnswers')?.basicInfo?.email || '';
  if (!Email.includes('test@fair.inc')) {
    try {
      let LEAD_UPSERT_API_PAYLOAD = {};
      Object.keys(data).forEach((key) => {
        if (key !== 'Base64_Signature') {
          LEAD_UPSERT_API_PAYLOAD = {
            ...LEAD_UPSERT_API_PAYLOAD,
            [key]: data[key],
          };
        }
      });
      const LEAD_API_URL = `${BACKEND_API_BASE_URL}/${type}`;
      const response = await fetch(LEAD_API_URL, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: [{ Email, ...LEAD_UPSERT_API_PAYLOAD }] }),
      });
      if (response.status === 500 || (response.status === 400 && type === 'lead')) {
        await handleZohoUpsert(data, 'contact', attempt + 1);
        return;
      }
      // if (data.Base64_Signature) {
      //   const res = await updateClaim({
      //     ip_address: data?.Signature_IP_Address || '',
      //   }); // this will update the sign url if signature is present from backend
      //   const sign_url = res?.success ? res?.responseObject?.data?.signature_url : undefined;

      //   if (sign_url) {
      //     const curRes = await axios.patch(LEAD_API_URL, {
      //       data: [
      //         {
      //           Email,
      //           Signature_URL: sign_url,
      //           ...LEAD_UPSERT_API_PAYLOAD,
      //         },
      //       ],
      //     });
      //     console.log('ZOHO call completed:', curRes);
      //   } else {
      //     console.log('Skipping updateClaim as the URL is empty or invalid.');
      //   }
      // }
    } catch (e) {
      console.log('ERROR::lead upsert', e);
      if (type === 'lead') {
        await handleZohoUpsert(data, 'contact', attempt + 1);
      }
    }
  }
};

export const getClaimNumber = (claimNumber?: string = '') => {
  return (
    claimNumber ||
    loadFromStorage('currentId') ||
    loadFromSessionStorage('currentId') ||
    getCookie('currentId') ||
    ''
  );
};

export const getUserAnswers = () => {
  return loadFromStorage('userAnswers') || loadFromSessionStorage('userAnswers') || {};
};

export const getCurrentDatetimeUtcFormatted = (date: Date = new Date()) => {
  const now = date;
  const utcYear = now.getUTCFullYear();
  const utcMonth = (now.getUTCMonth() + 1).toString()?.padStart(2, '0'); // Months are 0-indexed
  const utcDay = now.getUTCDate().toString()?.padStart(2, '0');
  const utcHours = now.getUTCHours().toString()?.padStart(2, '0');
  const utcMinutes = now.getUTCMinutes().toString()?.padStart(2, '0');
  const utcSeconds = now.getUTCSeconds().toString()?.padStart(2, '0');

  return `${utcYear}-${utcMonth}-${utcDay}T${utcHours}:${utcMinutes}:${utcSeconds}`;
};

export const setClaimNumberValue = (claimNumberValue = '') => {
  if (claimNumberValue !== '') {
    fallBackClaimNumber = claimNumberValue;
    setCookie('currentId', claimNumberValue, 90);
  }
};

export const triggerCustomerLabsHook = (payload) => {
  fetch(`https://hook.customerlabs.co/source/zoho-lead-7195/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...payload,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      triggerDiscordMessage({
        content: `Customer Labs hook triggered successfully for claim_id: ${payload?.claim_id || ''}`,
        bot: DISCORD_BOTS.TEST_BOT,
      });
      console.log('Customer Labs hook triggered successfully:', data);
    })
    .catch((error) => {
      triggerDiscordMessage({
        content: `ERROR TRIGGERING: Customer Labs hook triggered successfully for claim_id: ${payload?.claim_id || ''}`,
        bot: DISCORD_BOTS.TEST_BOT,
      });
      console.error('Error triggering Customer Labs hook:', error);
    });
};

export const convertDateToYYYYMMDD = (dateString) => {
  // Clear any previous error messages
  // document.getElementById('errorMessage').textContent = '';

  // Regular expression to validate DD/MM/YYYY format
  const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = dateString.match(dateRegex);

  if (!match) {
    // If the input doesn't match the expected format
    // document.getElementById('errorMessage').textContent = 'Invalid date format. Please use DD/MM/YYYY.';
    return '';
  }

  // Extract day, month, and year from the matched groups
  const day = match[1];
  const month = match[2];
  const year = match[3];

  // Basic validation for date components (e.g., month 1-12, day 1-31)
  const d = parseInt(day, 10);
  const m = parseInt(month, 10);
  const y = parseInt(year, 10);

  if (m < 1 || m > 12 || d < 1 || d > 31 || y < 1000 || y > 9999) {
    // document.getElementById('errorMessage').textContent = 'Invalid date values.';
    return '';
  }

  // Construct the "YYYYMMDD" string
  return `${year}${month}${day}`;
};

export const triggerSignedupEvent = ({ payload = {} }) => {
  triggerSub2DataLayer(SUB2_EVENTS.signed_up, { ...payload });
  saveToStorage('sign-notificaiton-sent', 'YES');
};

export const getOneThirdExperimentGroup = () => {
  const storedGroup = localStorage.getItem('experimentGroup');

  // If the user is already assigned a group, return it
  if (storedGroup) {
    return storedGroup;
  }

  // Generate a random number
  const randomValue = Math.random();

  let newGroup;

  // Assign the user to a group based on the random number
  if (randomValue < 0.33) {
    newGroup = 'v3'; // 33% of users get Group A
  } else if (randomValue < 0.66) {
    newGroup = 'v4'; // 33% of users get Group B
  } else {
    newGroup = 'v5'; // 34% of users get Group C
  }

  // Store the group for future visits
  localStorage.setItem('experimentGroup', newGroup);

  return newGroup;
};

export const getPageTitleFormatted = (pageName?: string) => {
  const currentJourney = getJourneyVersion();
  return pageName
    ? `Fair.inc ${currentJourney ? `| ${currentJourney}` : ''} | ${pageName}`
    : 'Fair.inc | Claim Mis-Sold PCP & HP Car Finance Refunds';
};

export const parseUserAgent = (ua) => {
  // This is a best-effort parser. User agent strings can be complex and sometimes misleading.
  if (!ua) return 'Unknown Device';

  let device = 'Unknown Device';

  // iPhone
  if (/\b(iPhone)\b/i.test(ua)) {
    device = 'Apple iPhone';
  }
  // iPad
  else if (/\b(iPad)\b/i.test(ua)) {
    device = 'Apple iPad';
  }
  // Mac
  else if (/\b(Macintosh|Mac OS X)\b/i.test(ua)) {
    device = 'Apple Mac';
  }
  // Windows
  else if (/\b(Windows)\b/i.test(ua)) {
    device = 'Windows PC';
  }
  // Android - more generic
  else if (/\b(Android)\b/i.test(ua)) {
    device = 'Android Device';
    // Try to get more specific for some common brands
    const samsungMatch = ua.match(/\b(SM-[A-Z0-9]{4,})\b/);
    if (samsungMatch) device = `Samsung Galaxy (${samsungMatch[1]})`;

    const pixelMatch = ua.match(/Pixel\s([\d\w\s]+)/i);
    if (pixelMatch) device = `Google Pixel (${pixelMatch[1].trim()})`;
  }
  // Linux
  else if (/\b(Linux)\b/i.test(ua)) {
    device = 'Linux Device';
  }

  return device;
};

export const getAgeRange = (age) => {
  // Ensure the input is a valid number.
  if (typeof age !== 'number' || isNaN(age)) {
    console.error('Invalid input. Please provide a valid number.');
    return null;
  }

  // Calculate the start of the age range by flooring the age divided by 10 and multiplying by 10.
  const start = Math.floor(age / 10) * 10;

  // Calculate the end of the age range.
  const end = start + 9;

  // Return the formatted string.
  return `${start}_${end}`;
};

export const getCreditScoreRange = (score) => {
  // Ensure the input is a valid number.
  if (typeof score !== 'number' || isNaN(score)) {
    console.error('Invalid input. Please provide a valid number.');
    return null;
  }

  // Calculate the start of the credit score range by flooring the score divided by 50 and multiplying by 50.
  const start = Math.floor(score / 50) * 50;

  // The end of the range is the next 50-point increment.
  const end = start + 50;

  // Return the formatted string.
  return `${start}_${end}`;
};

export const getJourneyLink = () => {
  // const journeyVersion = getOneThirdExperimentGroup() || 'v3';
  const journeyVersion = 'v9';
  const journeyStartLink = `/get-started-${journeyVersion}`;
  const queryString = window.location.href?.split('?')[1] || '';
  return `${journeyStartLink}${queryString ? `?${queryString}` : ''}`;
};
export const clearAllSessionData = async () => {
  try {
    // 1. Call backend to clear server-side session and cookies
    await fetch(`${BACKEND_API_BASE_URL}/session/clear`, {
      method: 'POST',
      credentials: 'include',
    });
    console.log('Backend session cleared successfully');
  } catch (error) {
    console.error('Error clearing backend session:', error);
    // Proceed to clear frontend storage anyway
  }

  // 2. Clear Local Storage
  const isPartnerMode = localStorage.getItem('is_partner_mode');
  localStorage.clear();
  if (isPartnerMode) {
    localStorage.setItem('is_partner_mode', isPartnerMode);
  }

  // 3. Clear Session Storage
  sessionStorage.clear();

  // 4. Clear Document Cookies (accessible ones)
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  }

  console.log('Frontend session data cleared');
};

export const handleZohoTicket = async (data: {
  email: string;
  feedback: string;
  name: string;
  contact: string;
}) => {
  try {
    const response = await fetch(`${BACKEND_API_BASE_URL}/zoho-feedback`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.error('Error creating Zoho ticket:', error);
    return null;
  }
};

export const formatDate = (dateString: string): string => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

export const getDeviceAndCameraInfo = async () => {
  try {
    const deviceInfo = parseUserAgent(navigator.userAgent);
    if (!navigator.permissions || !navigator.permissions.query) {
      throw new Error('Permissions API is not supported in this browser.');
    }
    const permissionStatus = await navigator.permissions.query({
      name: 'camera' as PermissionName,
    });
    return {
      deviceInfo: deviceInfo,
      cameraPermission: permissionStatus.state,
    };
  } catch (error: any) {
    console.error('Error getting device info:', error);
    return {
      deviceInfo: 'Could not determine device',
      cameraPermission: `Error (${error.message})`,
    };
  }
};

export const getDaysDifference = (utcString: string): string => {
  const utcDate = new Date(utcString);
  const currentDate = new Date();
  const differenceInMs = currentDate.getTime() - utcDate.getTime();
  const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));

  if (differenceInDays < 1) {
    const differenceInHours = Math.floor(differenceInMs / (1000 * 60 * 60));
    if (differenceInHours < 1) {
      const differenceInMinutes = Math.floor(differenceInMs / (1000 * 60));
      if (differenceInMinutes < 1) {
        return 'Just now';
      }
      return `${differenceInMinutes} mins`;
    } else {
      return `${differenceInHours} hours`;
    }
  } else {
    return `${differenceInDays} days`;
  }
};
